import { createRegionals, updateRegionals } from 'api/regionals';

import type { FormType } from '..';

export const regionalForm:FormType = {
  createFn: createRegionals,
  updateFn: updateRegionals,
  cancelText: 'Cancelar',
  submitText: 'Salvar Regional',
  disableText: 'Desativar Regional',
  enableText: 'Reativar Regional',
  successText: 'Regional salva com sucesso!',
  fields: [
    [{
      name: 'name',
      type: 'text',
      required: true,
      props: {
        placeholder: 'Sudeste',
        label: 'Nome',
      },
    }],
    [{
      name: 'area',
      type: 'text',
      required: false,
      props: {
        placeholder: 'Brasil',
        label: 'Localidade',
      },
    },
    ],
  ],
};
